module.exports = __webpack_public_path__ + "media/images/tl/banner/ko-2-light-72b78ee964fd4b06a1246fe312c18532.jpg";